import React, { useEffect, useRef, useState } from 'react';
import Spinner from './Spinner';
import { elementsCountByKey } from '../utils/scroll-restoration';
import { useLocation } from 'react-router-dom';

export let elementsCount = null;

function DefaultAutoloader(props) {
    const items = props.items;
    const limit = props.limit;
    const [count, setCount] = useState(limit);
    const toRender = useRef(limit);
    
    const observerRef = (node) => {
        if (node != null && items.length > count) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        if (toRender.current !== count) {
                            return;
                        }
                        setCount(prevCount => {
                            let newCount = null;
                            const rendered = prevCount;
                            const remaining = items.length - rendered;
                            if (remaining > limit) {
                                newCount = rendered + limit;
                            } else {
                                observer.disconnect();
                                newCount = items.length;
                            }
    
                            toRender.current = newCount;
                            elementsCount = newCount;
                            return newCount;
                        });
                    }
                });
            });
            observer.observe(node);
        }
    };
    
    return (
        <>
            {items.slice(0, count)}
            {count < items.length &&
                <div className="w-full flex items-center justify-center" ref={observerRef}>
                    <Spinner />
                </div>
            }
        </>
    );
}

window.restoreScrollPosition = null;

function RestorePositionAutoLoader(props) {
    const items = props.items;
    const limit = props.limit;
    const [count, setCount] = useState(limit);
    const toRender = useRef(limit);
    const skip = useRef(false);

    useEffect(() => {
        if (skip.current === false) {
            if (props.elementsCount && props.elementsCount > count) {
                setCount(prev => prev += limit);
            } else {
                const scrollerContainer = document.getElementById('xs-scroller-container');
                if (scrollerContainer != null) {
                    const prevScrollingPosition = props.scrollPosition;
                    if (prevScrollingPosition) {
                        scrollerContainer.scrollTop = prevScrollingPosition;
                    }
                }
                skip.current = true;
            }
        }
    });
    
    const observerRef = (node) => {
        if (node != null && items.length > count) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        if (toRender.current !== count) {
                            return;
                        }
                        setCount(prevCount => {
                            let newCount = null;
                            const rendered = prevCount;
                            const remaining = items.length - rendered;
                            if (remaining > limit) {
                                newCount = rendered + limit;
                            } else {
                                observer.disconnect();
                                newCount = items.length;
                            }
    
                            toRender.current = newCount;
                            elementsCount = newCount;
                            return newCount;
                        });
                    }
                });
            });
            observer.observe(node);
        }
    };
    
    return (
        <>
            {items.slice(0, count)}
            {count < items.length &&
                <div className="w-full flex items-center justify-center" ref={observerRef}>
                    <Spinner />
                </div>
            }
        </>
    );
}

export default function AutoLoader(props) {
    const location = useLocation();

    if (elementsCountByKey.has(location.pathname)) {
        const data = elementsCountByKey.get(location.pathname);
        const elementsCount = data.elementsCount;
        const scrollPosition = data.scrollPosition;
        return <RestorePositionAutoLoader {...props} elementsCount={elementsCount} scrollPosition={scrollPosition} location={location.pathname} />;
    }

    return <DefaultAutoloader {...props} />;
}
